export default "__VITE_ASSET__BRXDSQdG__"